"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreatePresentingSessionBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateCreatePresentingSessionBody = (0, validation_1.properties)({
    description: (0, validation_1.text)(),
    presentationId: (0, validation_1.optional)((0, validation_1.text)()),
    presentationTitle: (0, validation_1.optional)((0, validation_1.text)()),
    presentationType: (0, validation_1.optional)((0, validation_1.text)()),
    presentationStatus: (0, validation_1.optional)((0, validation_1.text)()),
    OS: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=CreatePresentingSessionBody.js.map